import { Banner } from '@sunwebgroup/uds-ui/banner'
import * as React from 'react'
import { useCMSPageField } from '@/cms/fields'
import { CheckoutSection } from '@/scopes/checkout/components/CheckoutSection'
import { useCheckoutSid, usePriceOverviews } from '@/scopes/checkout/domain/hooks'
import { getIconForService } from '../ServiceIcon'
import { BreakDownTable } from './BreakDownTable'
import { MandatoryCosts } from './MandatoryCost'

export function CheckoutPriceOverview(props: { glyph: string, type: 'PriceOverview' | 'PriceOverviewPerPerson' }) {
  const { glyph, type } = props
  const sid = useCheckoutSid()
  const priceOverview = (useCMSPageField('Checkout.items')?.items ?? []).find(item => item.type === type)
  const { data, isLoading } = usePriceOverviews(priceOverview?.componentId)

  if (!sid) {
    return null
  }

  if (!priceOverview) {
    return ''
  }

  if (isLoading)
    return ''
  if (!data)
    return ''

  return (
    <CheckoutSection title={priceOverview.componentTitle ?? ''} glyph={getIconForService(glyph)}>
      {data.warningMessage && (
        <Banner color="informative" size="M">
          <Banner.TextsWrapper>
            <Banner.SupportingText innerHTML={data.warningMessage} />
          </Banner.TextsWrapper>
        </Banner>
      )}
      <BreakDownTable items={data.items ?? []} />
      <MandatoryCosts mandatoryCosts={data?.mandatoryCosts ?? []} mandatoryHeader={data?.mandatoryCostHeader ?? ''} />
    </CheckoutSection>
  )
}
